import Cookies from 'js-cookie';
import { z } from 'zod';

export const CloudflareTraceSchema = z.object({
  ip: z.string().optional(),
  uag: z.string().optional(),
  loc: z.string().optional(),
});

export type CloudflareTrace = z.infer<typeof CloudflareTraceSchema>;

export async function getCfTrace(): Promise<CloudflareTrace | null> {
  const url =
    import.meta.env.VITE_APP_ENV === 'local'
      ? 'https://pages.dev/cdn-cgi/trace'
      : '/cdn-cgi/trace';
  const data = await fetch(url)
    .then(async (res) => await res.text())
    .catch(() => null);

  if (data === null) {
    return null;
  }

  const arr = data
    .trim()
    .split('\n')
    .map((e): [string, string] => e.split('=') as [string, string]);
  const rawTrace = Object.fromEntries(arr);
  const result = CloudflareTraceSchema.safeParse(rawTrace);

  if (!result.success) {
    return null;
  }

  const country = result.data.loc;

  if (country !== undefined) {
    Cookies.set('country', country);
  }

  return result.data;
}
